/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from '@irian-ro/abstract-resource';
import {TermsAndConditionsTypeEnum} from './terms-and-conditions-type.enum';

export class TermsAndConditionsAgreementVoModel extends JSONable {

  createdAt: string | undefined = undefined;
  uuid: string | undefined = undefined;
  attachmentUuid: string | undefined = undefined;
  userUuid: string | undefined = undefined;
  userName: string | undefined = undefined;
  userLanguage: string | undefined = undefined;
  userEmail: string | undefined = undefined;
  documentType: TermsAndConditionsTypeEnum | undefined = undefined;
  documentVersion: string | undefined = undefined;
  documentLanguage: string | undefined = undefined;
  validFrom: Date | undefined = undefined;
  validTo: Date | undefined = undefined;
  companyDataValidated: boolean | undefined = undefined;

}
